/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersList } from "../funcs/userSessionIssuersList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListUserSessionIssuersRequest,
  ListUserSessionIssuersResponse,
  ListUserSessionIssuersSecurity,
} from "../models/operations/listusersessionissuers.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type UserSessionIssuersQueryData = ListUserSessionIssuersResponse;

export type UserSessionIssuersInfiniteQueryData = PageIterator<
  ListUserSessionIssuersResponse,
  { cursor: string }
>;

export type UserSessionIssuersPageParams = PageIterator<
  ListUserSessionIssuersResponse,
  { cursor: string }
>["~next"];

export function prefetchUserSessionIssuers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionIssuersRequest | undefined,
  security?: ListUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionIssuersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchUserSessionIssuersInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionIssuersRequest | undefined,
  security?: ListUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildUserSessionIssuersInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as UserSessionIssuersPageParams,
    getNextPageParam: (previousPage: UserSessionIssuersInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildUserSessionIssuersQuery(
  client$: GramCore,
  request?: ListUserSessionIssuersRequest | undefined,
  security?: ListUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionIssuersQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionIssuers({
      cursor: request?.cursor,
      limit: request?.limit,
      mcpResourceId: request?.mcpResourceId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionIssuersQueryFn(
      ctx,
    ): Promise<UserSessionIssuersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionIssuersList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildUserSessionIssuersInfiniteQuery(
  client$: GramCore,
  request?: ListUserSessionIssuersRequest | undefined,
  security?: ListUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, UserSessionIssuersPageParams>,
  ) => Promise<UserSessionIssuersInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionIssuersInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      mcpResourceId: request?.mcpResourceId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionIssuersQuery(
      ctx,
    ): Promise<UserSessionIssuersInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(userSessionIssuersList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(userSessionIssuersList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyUserSessionIssuers(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    mcpResourceId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionIssuers", "list", parameters];
}

export function queryKeyUserSessionIssuersInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    mcpResourceId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionIssuers", "list", "infinite", parameters];
}
